// @flow

// Scroll to the element with the id specified by the hash.
export const scrollToHash = (hash: string) => {
  if (hash === '') {
    return false;
  }
  const id = hash.substr(1);
  const el = document.getElementById(id);

  if (el) {
    el.scrollIntoView();
    return true;
  }

  return false;
};
